import { render, staticRenderFns } from "./WeeklyReport.vue?vue&type=template&id=63947b5e&"
import script from "./WeeklyReport.vue?vue&type=script&lang=ts&"
export * from "./WeeklyReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports